import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';

const CreateWageButton: React.FunctionComponent = () => (
    <div className={classNames('text-right')}>
        <Link to={Router.generate(routes.WAGE_CREATE)} className={`${'btn btn-success'}`}>
            <span>Create</span>
        </Link>
    </div>
);

export default CreateWageButton;
